<script>
import { validate } from '../../utils/utils'
import CampaignTypeSelector from '../cc/campaign-setup/CampaignTypeSelector'
import Card from '../../slds/Card'
import GenericFilter from '../../campaign-manager/filters/GenericFilter'
import HasMode from '../../utils/HasMode'
import Input from '../../slds/Input'
import moment from 'moment'
import OutputField from '../../slds/OutputField'
import Picklist from '../../slds/Picklist'
import Spinner from '../../Spinner'
import TextArea from '../../slds/TextArea'
export default {
  mixins: [HasMode],
  components: {
    Card,
    CampaignTypeSelector,
    GenericFilter,
    Input,
    OutputField,
    Picklist,
    Spinner,
    TextArea
  },
  props: {
    campaignStatus: String,
    loading: Boolean,
    mode: String
  },
  methods: {
    async callLoadFromStore () {
      const campaign = this.loadFromStore('campaignData', ['loading', 'oldConfig'])

      this.localConfig = this.$store.getters['campaignDesigner/state'].currentCampaignConfig

      if (this.localConfig.campaignData.masterKey && this.localConfig.campaignData.masterKey.options) {
        this.masterKeys = this.localConfig.campaignData.masterKey.options
      } else {
        this.masterKeys = (await this.$store.dispatch('settings/getSettings')).masterKeys
      }

      if (campaign.config.campaignData && campaign.config.campaignData.type && campaign.config.campaignData.type.selected) {
        const selectedType = campaign.config.campaignData.type.selected
        this.campaignType = {
          label: selectedType.name,
          value: selectedType.code,
          color: selectedType.color,
          disableOrchestrationFlagEditable: selectedType.disableOrchestrationFlagEditable,
          disableOrchestrationFlagDefault: selectedType.disableOrchestrationFlagDefault
        }
      }

      if (!this.contributionType) {
        this.contributionType = ''
      }
    },
    getSectionToSave () {
      const campaignType = {
        options: this.localConfig.campaignData.type.options,
        selected: this.localConfig.campaignData.type.options.find(type => type.code === this.campaignType.value)
      }

      const sectionToSave = {
        flat: {
          brands: this.campaignBrands,
          ccdbReportEnabled: this.ccdbReportEnabled,
          ccdbReportType: this.ccdbReportType,
          contentClassification: this.contentClassification,
          contributionType: this.contributionType,
          description: this.description,
          finality: this.finality,
          marketCodes: this.markets,
          endDate: moment(this.endDate).format('YYYY-MM-DD'),
          manager: this.manager,
          masterKey: this.masterKey,
          name: this.name,
          onlyHeader: true,
          recordType: 'technical',
          segmentType: this.segmentType,
          touchpoint: this.touchpoint,
          type: this.campaignType.value,
          startDate: moment(this.startDate).format('YYYY-MM-DD')
        },
        config: {
          campaignBrands: {
            options: this.localConfig.campaignData.campaignBrands.options,
            selected: this.campaignBrands
          },
          campaignChannel: {
            options: this.localConfig.campaignData.campaignChannel.options,
            selected: this.campaignChannel
          },
          ccdbReportEnabled: {
            options: this.localConfig.campaignData.ccdbReportEnabled.options,
            selected: this.ccdbReportEnabled
          },
          ccdbReportType: {
            options: this.localConfig.campaignData.ccdbReportType.options,
            selected: this.ccdbReportType
          },
          contentClassification: {
            options: this.localConfig.campaignData.contentClassification.options,
            selected: this.contentClassification
          },
          contributionType: {
            options: this.localConfig.campaignData.contributionType.options,
            selected: this.contributionType
          },
          description: this.description,
          favorite: {
            options: this.localConfig.campaignData.favorite.options,
            selected: this.favorite
          },
          finality: {
            options: this.localConfig.campaignData.finality.options,
            selected: this.finality
          },
          manager: {
            options: this.localConfig.campaignData.manager.options,
            selected: this.manager
          },
          markets: {
            options: this.localConfig.campaignData.markets.options,
            selected: this.markets
          },
          masterKey: {
            selected: this.masterKey
          },
          seed: {
            options: this.localConfig.campaignData.seed.options,
            selected: this.seed
          },
          segmentType: {
            options: this.localConfig.campaignData.segmentType.options,
            selected: this.segmentType
          },
          type: campaignType
        }
      }

      if (this.localConfig.campaignData.touchpoint) {
        sectionToSave.flat.touchpoint = this.touchpoint
        sectionToSave.config.touchpoint = {
          options: this.localConfig.campaignData.touchpoint.options,
          selected: this.touchpoint
        }
      }

      return sectionToSave
    },
    validate () {
      if (this.isCreate || this.isEdit) {
        return validate(this, 'data', true)
      } else {
        const dateFrom = moment(this.startDate, 'YYYY-MM-DD')
        if (this.campaignStatus === 'Draft' && dateFrom.isBefore(moment(), 'day')) {
          this.showToast('error', this.$t('validation.invalidData'), 'text', this.$t('campaignDesigner.campaignSetup.validation.startDateMustBeInFuture'))
        } else {
          return true
        }
      }
    }
  },
  beforeCreate () {
    this.$emit('startLoading')
  },
  created () {
    this.callLoadFromStore()
    this.$emit('endLoading')
  },
  data () {
    return {
      campaignBrands: [],
      campaignChannel: [],
      campaignType: {},
      ccdbReportEnabled: false,
      ccdbReportType: '',
      contentClassification: '',
      contributionType: '',
      description: '',
      endDate: '',
      favorite: false,
      finality: '',
      localConfig: {},
      manager: '',
      markets: [],
      masterKey: '',
      masterKeys: [],
      name: '',
      onlyHeader: true,
      recordType: 'technical',
      seed: false,
      segmentType: '',
      startDate: '',
      touchpoint: '',
      type: ''
    }
  },
  watch: {
    masterKey (value) {
      if (value === '') {
        this.masterKey = null
      }
    }
  }
}
</script>
<template>
  <div class="full-height">
    <Spinner v-if="loading" />

    <div v-else-if="localConfig && localConfig.campaignData" class="full-height">
      <Card class="full-height">
        <!-- Name, type -->
        <div class="row">
          <!-- Name -->
          <div class="slds-form-element col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.name')"
                :validation="['required']"
                ref="data_name"
                v-if="isCreate || isEdit"
                v-model="name" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.name')"
                :value="name"
                v-else />
            </div>
          </div>

          <!-- Campaign type selection -->
          <div class="slds-form-element slds-size--medium col">
            <CampaignTypeSelector
              ref="data_campaignType"
              v-if="isCreate && localConfig.campaignData.type.options.length > 1"
              v-model="campaignType"
              :options="localConfig.campaignData.type.options"
              :validation="['required']" />

            <OutputField :label="$t('campaignDesigner.campaignSetup.type.label')" type="custom" v-else>
              <span class="slds-swatch type-color-container" :style="`background:${campaignType.color ? campaignType.color: '#FFFFFF'};`" />
              <span>{{campaignType.label}}</span>
            </OutputField>
          </div>
        </div>

        <!-- Masterkey, Market -->
        <div class="row">
          <!-- Masterkey campaign -->
          <div class="slds-form-element slds-size--medium col" v-if="masterKeys && masterKeys.length">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.masterKey')"
              :options="masterKeys"
              :validation="['required']"
              show-empty-value
              ref="data_masterkey"
              searchable
              v-if="isCreate || isEdit"
              v-model="masterKey" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.masterKey')"
              :value="masterKey"
              type="custom"
              v-else>

              <span v-if="masterKeys && masterKeys.length && masterKey">{{masterKey.length && masterKeys.find(mk => mk.value === masterKey).label}}</span>
            </OutputField>
          </div>

          <!-- Market -->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.market')"
              :options="localConfig.campaignData.markets.options"
              :validation="['required']"
              labels-prefix="markets"
              multipicklist
              ref="data_markets"
              v-if="(isCreate || isEdit)"
              v-model="markets" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.market')"
              :options="localConfig.campaignData.markets.options"
              :value="markets"
              labels-prefix="markets"
              type="multipicklist"
              v-else />
          </div>
        </div>

        <!-- Start date, End date -->
        <div class="row">
          <!-- Start date -->
          <div class="slds-form-element col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.startDate')"
                :validation="[{name: 'is-date-before', param: endDate}, 'is-date-after-today', 'required']"
                ref="data_startDate"
                type="date"
                v-if="isCreate || isEdit"
                v-model="startDate" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.startDate')"
                :value="startDate"
                type="date"
                v-else />
            </div>
          </div>

          <!-- End date -->
          <div class="slds-form-element slds-size--medium col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.endDate')"
                :validation="['required', 'is-date-after-today']"
                ref="data_endDate"
                type="date"
                v-if="isCreate || isEdit"
                v-model="endDate" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.endDate')"
                :value="endDate"
                type="date"
                v-else />
            </div>
          </div>
        </div>

        <!-- Brands, Channels -->
        <div class="row">
          <!-- Brands -->
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.brands')"
              :options="localConfig.campaignData.campaignBrands.options"
              :validation="['required']"
              labels-prefix="brands"
              multipicklist
              ref="data_brands"
              v-if="(isCreate || isEdit)"
              v-model="campaignBrands" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.brands')"
              :options="localConfig.campaignData.campaignBrands.options"
              :value="campaignBrands"
              labels-prefix="brands"
              type="multipicklist"
              v-else />
          </div>

          <!-- Channels -->
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.channels.label')"
              :options="localConfig.campaignData.campaignChannel.options"
              :validation="['required']"
              labels-prefix="channels"
              multipicklist
              ref="data_channels"
              v-if="isCreate || isEdit"
              v-model="campaignChannel" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.channels.label')"
              :options="localConfig.campaignData.campaignChannel.options"
              :value="campaignChannel"
              labels-prefix="channels"
              type="multipicklist"
              v-else />
          </div>
        </div>

        <!-- Contribution Type, Segment Type -->
        <div class="row">
          <!-- Contribution Type -->
          <div class="slds-form-element col slds-size--medium">
            <GenericFilter
              filter-type="included"
              is-picklist
              labels-prefix="campaignDesigner.campaignSetup.contributionType"
              v-if="isCreate || isEdit"
              v-model="contributionType"
              :options="localConfig.campaignData.contributionType.options"
              :label="$t('campaignDesigner.campaignSetup.contributionType.label')" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.contributionType.label')"
              :options="localConfig.campaignData.contributionType.options"
              :value="contributionType"
              labels-prefix="campaignDesigner.campaignSetup.contributionType"
              type="picklist"
              v-else />
          </div>

          <!-- Segment Type -->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.segmentType.label')"
              :options="localConfig.campaignData.segmentType.options"
              :validation="['required']"
              labels-prefix="campaignDesigner.campaignSetup.segmentType"
              ref="data_segmentType"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="segmentType" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.segmentType.label')"
              :options="localConfig.campaignData.segmentType.options"
              :value="segmentType"
              labels-prefix="campaignDesigner.campaignSetup.segmentType"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Seed, Content Classification -->
        <div class="row">
          <!-- Seed -->
          <div class="slds-form-element col slds-size--medium">
            <Input
              :label="$t('campaignDesigner.campaignSetup.seed')"
              type="checkbox"
              v-if="isCreate || isEdit"
              v-model="seed" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.seed')"
              :value="seed"
              type="checkbox"
              v-else />
          </div>

          <!-- Content Classification -->
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.contentClassification.label')"
              :options="localConfig.campaignData.contentClassification.options"
              :validation="['required']"
              labels-prefix="campaignDesigner.campaignSetup.contentClassification"
              ref="data_contentClassification"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="contentClassification" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.contentClassification.label')"
              :options="localConfig.campaignData.contentClassification.options"
              :value="contentClassification"
              labels-prefix="campaignDesigner.campaignSetup.contentClassification"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Finality, Manager -->
        <div class="row">
          <!-- Finality -->
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.finality.label')"
              :options="localConfig.campaignData.finality.options"
              :tooltip="$t('campaignDesigner.campaignSetup.finality.tooltip.afterSales')"
              :validation="['required']"
              tooltip-direction="right"
              labels-prefix="campaignDesigner.campaignSetup.finality"
              ref="data_finality"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="finality" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.finality.label')"
              :options="localConfig.campaignData.finality.options"
              :value="finality"
              labels-prefix="campaignDesigner.campaignSetup.finality"
              type="picklist"
              v-else />
          </div>

          <!-- Manager -->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.manager.label')"
              :options="localConfig.campaignData.manager.options"
              labels-prefix="campaignDesigner.campaignSetup.manager"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="manager" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.manager.label')"
              :options="localConfig.campaignData.manager.options"
              :value="manager"
              labels-prefix="campaignDesigner.campaignSetup.manager"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- CCDB Report Enabled, CCDB Report Type -->
        <div class="row">
          <!-- CCDB Report Enabled -->
          <div class="slds-form-element col slds-size--medium">
            <Input
              :label="$t('campaignDesigner.campaignSetup.ccdbReportEnabled')"
              type="checkbox"
              v-if="isCreate || isEdit"
              v-model="ccdbReportEnabled" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.ccdbReportEnabled')"
              :value="ccdbReportEnabled"
              type="checkbox"
              v-else />
          </div>

          <!-- CCDB Report Type -->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.ccdbReportType.label')"
              :options="localConfig.campaignData.ccdbReportType.options"
              labels-prefix="campaignDesigner.campaignSetup.ccdbReportType"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="ccdbReportType" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.ccdbReportType.label')"
              :options="localConfig.campaignData.ccdbReportType.options"
              :value="ccdbReportType"
              labels-prefix="campaignDesigner.campaignSetup.ccdbReportType"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Description, Touchpoint -->
        <div class="row">
          <!-- Description -->
          <div class="slds-form-element col slds-size--medium">
            <div class="slds-form-element slds-size--medium">
              <TextArea
                :label="$t('campaignDesigner.campaignSetup.description')"
                v-if="isCreate || isEdit"
                v-model="description" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.description')"
                :value="description"
                type="text"
                v-else />
            </div>
          </div>

          <!-- Touchpoint -->
          <div class="slds-form-element slds-size--medium col" v-if="localConfig.campaignData.touchpoint">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.touchpoint')"
              :options="localConfig.campaignData.touchpoint.options"
              :validation="['required']"
              ref="data_touchpoint"
              required
              searchable
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="touchpoint" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.touchpoint')"
              :options="localConfig.campaignData.touchpoint.options"
              :value="touchpoint"
              type="picklist"
              v-else />
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  .col {
    flex-grow: 1;
  }

  .type-color-container {
    margin-right: 10px;
  }

  .full-height {
    height: 100%;
    overflow-y: auto;
  }

  Input {
    width: unset !important;
  }
</style>
